import React from "react";
import MaterialIcons from "../MaterialIcons";
import "./chip.scss";

const Chip = ({
	text = "Chip Text",
	size = "normal",
	color = "green",
	variant = "outline",
	icon,
	onClick,
	style,
	...rest
}) => {
	return (
		<button
			className={`chip 
			${size === "large" && "chip-lg"} 
			${size === "small" && "chip-sm"}`}
			style={{
				borderColor: `var(--${color})`,
				outlineColor: `var(--${color})`,
				transition: "all 0.25s ease-in-out",
				backgroundColor:
					variant === "fill" ? `var(--${color})` : "transparent",
				...style,
			}}
			onClick={onClick}
			{...rest}
		>
			<MaterialIcons>{icon}</MaterialIcons>
			<span>{text}</span>
		</button>
	);
};

export default Chip;
